import { useHttp } from '@/shared/lib'
import { useQuery } from '@tanstack/vue-query'
import { useRoute } from 'vue-router'
import { computed } from 'vue'

/**
 * Функция загрузки данных для вкладки сервисы
 */
export const useLoadCabinetAdminServices = () => {
  const http = useHttp()
  const route = useRoute()

  const url = computed(() => `/cabinets/${route.params.object_id}/admin/services/`)

  const queryKey = computed(() => ['load_cabinet_admin_services', route.params.object_id])

  return useQuery({
    queryKey,
    queryFn: () => http.get(url.value),
    retry: false,
  })
}
